export default {
  tip: '4a689498fa532c584c76dc64d0a2d27713c5e0630e0b1baa61d6d8961e0167a0',
  name: 'Lost Property',
  tabs: [
    {
      tabName: 'General',
      i18n_tabName: {
        'en-us': 'General',
      },
      rows: [
        {
          fields: [
            {
              key: 'title',
              type: 'input',
              templateOptions: {
                label: 'Title',
                i18n_label: {
                  'en-us': 'Title',
                },
                appearance: 'outline'
              },
              conditionalFields: {
                required: {
                  value: 'true' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'description',
              type: 'rich-text',
              templateOptions: {
                label: 'Description',
                i18n_label: {
                  'en-us': 'Description',
                },
                appearance: 'outline'
              },
              conditionalFields: {
                required: {
                  value: 'false' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'locationPropertyWasLastSeen',
              type: 'input',
              templateOptions: {
                label: 'Location',
                i18n_label: {
                  'en-us': 'Location',
                },
                appearance: 'outline',
                required: true,
              },
              conditionalFields: {
                required: {
                  value: 'true' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
            {
              key: 'dateItemWasLastSeen',
              type: 'date-time',
              templateOptions: {
                datetimepickerOptions: {
                  type: 'date',
                },
                label: 'Date property was last seen',
                i18n_label: {
                  'en-us': 'Date property was last seen',
                },
                dateFormat: null,
                timeFormat: null,
                timezone: 'User timezone',
                dateValidation: '',
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'false' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'itemColor',
              type: 'list-items-select',
              templateOptions: {
                label: 'Item colour',
                i18n_label: {
                  'en-us': 'Item colour',
                },
                placeholder: 'Select the colour of the item from the list',
                i18n_placeholder: {
                  'en-us': 'Select your option',
                },
                listItems: {
                  label: 'Item colour',
                  value: 'Item colour',
                  items: [
                    { label: 'Aqua', value: 'Aqua' },
                    { label: 'Black', value: 'Black' },
                    { label: 'Matte Black', value: 'Matt Black' },
                    { label: 'Blue - Dark', value: 'blueDark' },
                    { label: 'Blue - Light', value: 'blueLight' },
                    { label: 'Brown - Dark', value: 'brownDark' },
                    { label: 'Brown - Light', value: 'brownLight' },
                    { label: 'Bronze', value: 'Bronze' },
                    { label: 'Cherry', value: 'Cherry' },
                    { label: 'Clear', value: 'Clear' },
                    { label: 'Copper', value: 'Copper' },
                    { label: 'Cream', value: 'Cream' },
                    { label: 'Green - Dark', value: 'greenDark' },
                    { label: 'Green - Light', value: 'greenLight' },
                    { label: 'Green - Florescent ', value: 'greenFlorescent' },
                    { label: 'Fuscia', value: 'Fuscia' },
                    { label: 'Gold', value: 'Gold' },
                    { label: 'Gold - Rose', value: 'goldRose' },
                    { label: 'Navy', value: 'Navy' },
                    { label: 'Pink', value: 'Pink' },
                    { label: 'Orange', value: 'Orange' },
                    {
                      label: 'Orange - Florescent ',
                      value: 'orangeFlorescent',
                    },
                    { label: 'Purple - Dark', value: 'purpleDark' },
                    { label: 'Purple - Light', value: 'purpleLight' },
                    {
                      label: 'Purple - Florescent ',
                      value: 'purpleFlorescent',
                    },
                    { label: 'Other', value: 'Other' },
                    { label: 'Red', value: 'Red' },
                    { label: 'Silver', value: 'Silver' },
                    { label: 'Tan', value: 'Tan' },
                    { label: 'Teal', value: 'Teal' },
                    { label: 'White', value: 'White' },
                    { label: 'Yellow - Dark ', value: 'yellowDark' },
                    { label: 'Yellow - Light ', value: 'yellowLight' },
                    {
                      label: 'Yellow - Florescent ',
                      value: 'yellowFlorescent',
                    },
                  ],
                },
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'false' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'propertyType',
              type: 'list-items-select',
              templateOptions: {
                label: 'Property type',
                i18n_label: {
                  'en-us': 'Property type',
                },
                placeholder:
                  'Select the type of property that was lost or stolen',
                i18n_placeholder: {
                  'en-us':
                    'Select the type of property that was lost or stolen',
                },
                listItems: {
                  label: 'Property type',
                  value: 'Property type',
                  items: [
                    { label: 'Backpack', value: 'Backpack' },
                    { label: 'Bag', value: 'bag' },
                    { label: 'Books', value: 'books' },
                    { label: 'Briefcase', value: 'Briefcase' },
                    { label: 'Calculators', value: 'calculators' },
                    { label: 'Clothing', value: 'Clothing' },
                    { label: 'Diary', value: 'diary' },
                    {
                      label: 'Electronic cables/chargers',
                      value: 'electronicCablesChargers',
                    },
                    { label: 'Folders', value: 'folders' },
                    {
                      label: 'Glasses - Prescription ',
                      value: 'glassesPrescription',
                    },
                    {
                      label: 'Glasses - Sunglasses',
                      value: 'glassesSunglasses',
                    },
                    { label: 'Gym Bag', value: 'Gym Bag' },
                    { label: 'Keys', value: 'keys' },
                    { label: 'Laptop', value: 'Laptop' },
                    { label: 'Money', value: 'money' },
                    { label: 'Notebooks', value: 'notebooks' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Passport', value: 'passport' },
                    { label: 'Pencil Cases', value: 'pencilCases' },
                    { label: 'Purse', value: 'Purse' },
                    { label: 'Push bike', value: 'Push bike' },
                    { label: 'Radio', value: 'Radio' },
                    { label: 'Ring or Jewelry', value: 'Ring or Jewelry' },
                    { label: 'Smart Phone', value: 'Smart Phone' },
                    { label: 'Tablet', value: 'tablet' },
                    { label: 'Umbrellas', value: 'umbrellas' },
                    { label: 'USB Memory Stick', value: 'usbMemoryStick' },
                    { label: 'Wallet', value: 'Wallet' },
                    { label: 'Watch', value: 'Watch' },
                  ],
                },
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'false' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'uploadAPhotoOfTheItemIfPossible',
              type: 'file-upload',
              templateOptions: {
                label: 'Upload a photo of the object (if possible)',
                i18n_label: {
                  'en-us': 'Upload a photo of the object (if possible)',
                },
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'false' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              type: 'section-header',
              templateOptions: {
                label: '',
                title: 'Property owner',
                disabled: false,
                i18n_label: {
                  'en-us': '',
                },
                i18n_title: {
                  'en-us': 'Property owner',
                },
                appearance: 'outline'
              },
              conditionalFields: {},
            },
          ],
        },
        {
          fields: [
            {
              key: 'fullName',
              type: 'input',
              templateOptions: {
                label: 'Name of property owner',
                i18n_label: {
                  'en-us': 'Name of property owner',
                },
                appearance: 'outline'
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'phoneNumber',
              type: 'phone-number',
              templateOptions: {
                type: 'tel',
                label: 'Owner\'s phone number',
                i18n_label: {
                  'en-us': 'Owner\'s phone number',
                },
                required: true,
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'true' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
            {
              key: 'zid',
              type: 'input',
              templateOptions: {
                label: 'zID of property owner',
                i18n_label: {
                  'en-us': 'zID of property owner',
                },
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'false' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'emailAddressOfOwner',
              type: 'email-address',
              templateOptions: {
                type: 'email',
                label: 'Owner\'s email address',
                i18n_label: {
                  'en-us': 'Owner\'s email address',
                },
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'true' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
        {
          fields: [
            {
              key: 'ownerContactDetails',
              type: 'rich-text',
              templateOptions: {
                label: 'Alternative contact details',
                i18n_label: {
                  'en-us': 'Alternative contact details',
                },
                appearance: 'outline'
              },
              conditionalFields: {
                readonly: {
                  value: 'false' as const,
                  conditions: {},
                },
                required: {
                  value: 'false' as const,
                  conditions: {},
                },
                visibility: {
                  value: 'true' as const,
                  conditions: {},
                },
              },
            },
          ],
        },
      ],
    },
  ],
  formSpecVersion: '1',
  background: '',
  logo: '',
  logoPositioning: null,
};
